import { useHoofdstuk } from '@/api/queries/objects';
import { groupHoofdstukkenByGrondslag } from '@/constants/grondslagen';
import { queryClient } from '@/services/queryClient';
import { createInString } from '@/utils/createInString';
import { createQuery } from '@/utils/tanstack-query/createQuery';

type useViewerBesluitFilterGrondslagenProps = {
  besluitId: string;
  labelIds: string[];
};

const fetchViewerFilterHoofdstukken = async ({
  besluitId,
  labelIds,
}: useViewerBesluitFilterGrondslagenProps) => {
  const data = await queryClient.fetchQuery(
    useHoofdstuk.getOptions({
      page: 1,
      size: 100,
      filter: [
        {
          model: 'VSPB',
          field: 'Type',
          op: 'eq',
          value: 'Eigen',
        },
        {
          model: 'VSPB',
          field: 'Besluit',
          op: 'eq',
          value: besluitId,
        },
        // This PHB filter is necessary to avoid having multiple hoofdstukken from the same lineage
        {
          model: 'PHB',
          field: 'Besluit',
          op: 'eq',
          value: besluitId,
        },
        {
          model: 'Label',
          field: 'ID',
          op: 'in',
          value: createInString(labelIds),
        },
      ],
      sort: [
        {
          model: 'Hoofdstuk',
          field: 'Nummer',
          direction: 'asc',
        },
      ],
    })
  );

  return groupHoofdstukkenByGrondslag(data.objects ?? []);
};

export const useViewerBesluitFilterGrondslagen = createQuery({
  key: ['viewer-filter-hoofdstukken'],
  queryFn: fetchViewerFilterHoofdstukken,
});
